import React, { useContext, useState, useEffect } from 'react';
import { useFormik } from "formik";
import { useSelector, useDispatch } from "react-redux";
import AuthContext from  "../../context/AuthContext";
import { Button } from "primereact/button";
import { InputField } from "components/InputField/Input";
import { SaleValidationSchema } from 'utilities/ValidationSchema/Stock/SaleValidationSchema'; 
import useProductDataTable from './hook/useProductDataTable';
import { TableFormSale } from 'components/Table/TableFormSale';
import { AddSale } from 'services/sale/sale.service';
import { GetUserInfo } from 'services/user/user.service';
import { InputText } from "primereact/inputtext";
import { coreAxios } from "utilities/axios";
import { ProgressSpinner } from 'primereact/progressspinner';
import { GetStocksForSale } from 'services/stock/stock.service';

import { nullifySaleAdd } from "../../slices/sale/sale.slice";
import { nullifyUserInfo } from "../../slices/user/user.slice"

const BASE_URL = process.env.REACT_APP_MAIN_URL


const Sale = () => {
    const { user } = useContext(AuthContext);
    const dispatch = useDispatch();
    const {saleAdd, saleAddLoading } = useSelector((state) => state.saleAdd);
    const {userInfo, userInfoLoading } = useSelector((state) => state.userInfo);


    // Initial value for sale
    const createInitialValue = {
        emp_code: "milon-123",
        emp_name: "Md. Abdul Alim",
        designation: "Software Engineer",
        unit: "DRL",
        shop: user.shop_id,
        sale_items: [
            {
                id: 0,
                item: "",
                barcode: '',
                saleable_quantity: 0,
                saleable_rate: 0.0,
                sale_quantity: 0,
                total_price_per_item: 0.0,
            },
        ],
        total_price: 0,
    }

    // Formik
    const formik = useFormik({
        initialValues: createInitialValue, // * if state is update then updateData state value will show up
        validationSchema: SaleValidationSchema, // * yup schema validation
        onSubmit: (values) => {
            const modifiedData = {
                ...values,
                sale_items: values.sale_items.map((value) => {
                    return{
                        ...value,
                        item: value.item?.id,
                        stock_item_id: value.item?.saleable_stock_item_id,
                        saleable_rate: parseFloat(value.item?.saleable_rate),
                        saleable_quantity: value.item.saleable_quantity || 0, // adding 0 to avoid remain_quantity undefine
                        total_price_per_item: parseFloat((parseFloat(value.item?.saleable_rate) * value?.sale_quantity).toFixed(3))
                    }
                }),
            };
            handelSubmit(modifiedData);
        },
        enableReinitialize: true,
    });

    const { modalTableColumns, modalTableActionButton } = useProductDataTable(
        formik,
    );

    // form submit handler
    const handelSubmit = async (data) => {
        let total_price = 0

        for(let i=0; i< data.sale_items.length; i = i+1){
            if(typeof data.sale_items[i]['saleable_quantity'] !== 'undefined'){
                if(data.sale_items[i]['saleable_quantity'] !== 0){
                    total_price = total_price + data.sale_items[i]['total_price_per_item']
                }
            }
        }

        const modifiedData = {
            ...data,
            // total_price: data.sale_items.reduce((accumulator, currentValue) => accumulator + currentValue.total_price_per_item, 0) //The accumulator parameter represents the accumulated value from previous iterations.
            total_price: parseFloat(total_price).toFixed(3)
        }

        await dispatch(AddSale(modifiedData)).then((response) => {
            downloadInvoice(response.payload)
            formik.resetForm();
            dispatch(GetStocksForSale()); // Update sell item list after a successfull sell
            return
        });

        dispatch(nullifySaleAdd());
        dispatch(nullifyUserInfo())

    };

    const downloadInvoice = async (data) => {

        if(data.code === 200){
            const url = `${BASE_URL}/api/invoice/download/${data.invoice}/`;
            try {
                const response = await coreAxios.get(url, {
                  responseType: 'blob',
                });
                const downloadUrl = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = downloadUrl;
                link.setAttribute('download', `invoice-${data.invoice_no}.pdf`);
                document.body.appendChild(link);
                link.click();
            } catch(error){
              console.log(error)
            }
        }
    }

    // Initial value for sale
    const createInitialValue2 = {
        emp_code: "",
    }

    // Formik
    const formik1 = useFormik({
        initialValues: createInitialValue2, // * if state is update then updateData state value will show up
        // validationSchema: SaleValidationSchema, // * yup schema validation
        onSubmit: (values) => {
            handelSubmit2(values);
        },
        enableReinitialize: true,
    });

    // form submit handler
    const handelSubmit2 = async (data) => {

        formik1.resetForm();
        dispatch(GetUserInfo(data));

    };

    const inputData2 = [
        {
            id: "emp_code",
            name: "emp_code",
            value: "emp_code",
            type: "text",
            required: true,
            messagePosition: 'toast',
            className: "col-12 md:col-12",
        },
    ];

    useEffect(() => {
        dispatch(nullifyUserInfo())
    }, []);



    return (
        <React.Fragment>
            <div className='grid'>
                <div className='col-9'>
                    <form onSubmit={formik.handleSubmit}>
                        <div className="w-full">
                            <TableFormSale
                                emptyMessage="No data found"
                                tableColumns={modalTableColumns}
                                data={formik.values.sale_items}
                                loading={false}
                                dataKey="saleID"
                                type="sale"
                                actionButtonWidth={7}
                                actionButton={modalTableActionButton}
                            />
                        </div>
                        <div className='grid' style={{"marginTop": "-5px"}}>
                            <div className='col-8'>

                            </div>
                            <div className='col-4' style={{"textAlign": "center"}}>
                                <Button 
                                    type="submit"
                                    label={saleAddLoading ? "Loading" : "Submit"} 
                                    icon="pi pi-save"
                                    loading={saleAddLoading}
                                    style={{"fontSize": "1.3rem"}}
                                />
                            </div>
                        </div>
                    </form>
                </div>
                <div className='col-3'>
                    <div className="card">
                        <form onSubmit={formik1.handleSubmit} className={`grid grid-cols-4 mt-2 gap-x-3`}>
                            <div className='w-full' style={{"textAlign": "center", "fontSize": "1.3rem"}}>
                                Get Employee Information
                            </div>
                            {inputData2.map(({ id, name, value, type, labelFor, label, required, rows, className, autoCompleteMethod, autoFilteredValue, onBlur, onChange, errors, ...rest }) => (
                                <div key={id} className={`p-field ${className}`} >
                                    <InputField
                                        id={id}
                                        type={type}
                                        required={required}
                                        name={name}
                                        errors={errors || formik1.errors?.[id]?.id || formik1.errors[id]}
                                        label={label}
                                        labelFor={labelFor}
                                        rows={rows}
                                        width={"full"}
                                        value={formik1.values[name]}
                                        autoCompleteMethod={autoCompleteMethod}
                                        autoFilteredValue={autoFilteredValue}
                                        onChange={(...args) => {
                                            !onChange && formik1.handleChange(...args);
                                            onChange?.(...args);
                                        }}
                                        onBlur={onBlur}
                                        onClose={() => formik1.setErrors({})}
                                        {...rest}
                                    />
                                </div>
                            ))}
                        </form>
                    </div>
                    <div className="card">
                        {userInfoLoading ? 
                            <div style={{ height: "25vh", display: "flex", alignItems: "center", justifyContent: "center" }}>
                                <ProgressSpinner  style={{width: '100px', height: '100px'}} strokeWidth="3" fill="white" animationDuration="1s" />
                            </div> 
                        : 
                            userInfo ? 
                            <div style={{"fontSize": "15px"}}>
                                <p style={{"lineHeight": "0.6"}}><strong>Employee Code: </strong>{userInfo?.emp_code}</p>
                                <p style={{"lineHeight": "0.6"}}><strong>Name: </strong>{userInfo?.name}</p>
                                <p style={{"lineHeight": "0.6"}}><strong>Designation Limit: </strong>{userInfo?.designation_limit}</p>
                                <p style={{"lineHeight": "0.6"}}><strong>Limit Remain: </strong>{userInfo?.credit_remaining}</p>
                                <p style={{"lineHeight": "0.6"}}><strong>Monthly Credit: </strong>{userInfo?.monthly_credit}</p>
                                <p style={{"lineHeight": "0.6"}}><strong>Credit Taken: </strong>{userInfo?.credit_used}</p>
                                <p style={{"lineHeight": "0.6"}}><strong>Credit Remain: </strong>{userInfo?.credit_remaining}</p>
                                <p style={{"lineHeight": "0.6"}}><strong>Department: </strong>{userInfo?.department}</p>
                                <p style={{"lineHeight": "0.6"}}><strong>Designation: </strong>{userInfo?.designation}</p>
                                <p style={{"lineHeight": "0.6"}}><strong>Unit: </strong>{userInfo?.unit}</p>
                                <p style={{"lineHeight": "0.6"}}><strong>Address: </strong>{userInfo?.address}</p>
                            </div>
                            : ""
                        }
                    </div>
                </div>
            </div>
        </React.Fragment>
    )
}

export default Sale;